/**
 * Pure helpers for hiding protected routes from the nav tree. Extracted from
 * `app/composables/useContentRoute.ts` so the pruning grammar is unit-testable
 * without a Nuxt/prerender harness. The composable owns the memoized set that
 * feeds `hidden` (resolved from public runtimeConfig at synchronous setup time,
 * NOT after an await — see the regression the composable guards against).
 */

/** Build the hidden-route set from the public runtimeConfig list. */
export function buildHiddenSet(list: string[] | undefined): Set<string> {
  return list && list.length ? new Set(list) : new Set();
}

/**
 * Recursively drop nodes whose own `path` is hidden (removing their subtree).
 * Returns the input array unchanged when nothing is hidden so callers keep the
 * shared cached tree identity in the common (BFF-on) case.
 */
export function pruneHiddenNodes(nodes: any[], hidden: Set<string>): any[] {
  if (!hidden.size) return nodes
  const out: any[] = []
  for (const n of nodes) {
    if (n?.path && hidden.has(n.path)) continue
    const kids = n?.children ? pruneHiddenNodes(n.children, hidden) : n?.children
    out.push(kids === n?.children ? n : { ...n, children: kids })
  }
  return out
}
